import "./Card.css";

function Card({ info, index }) {
  const observeUrlChange = (e) => {
    let oldHref = document.location.href;
    const body = document.querySelector("body");
    const observer = new MutationObserver((mutations) => {
      if (oldHref !== document.location.href) {
        oldHref = document.location.href;
        e.target.closest(".flip-card-inner").style.transform = "none";
      }
    });
    observer.observe(body, { childList: true, subtree: true });
  };

  const handleClick = (e) => {
    console.log(e.target.closest(".flip-card-inner"));
    e.target.closest(".flip-card-inner").style.transform = "rotateY(180deg)";
    observeUrlChange(e);
  };

  return (
    <div className='flip-card' key={index} onClick={handleClick}>
      <div className='flip-card-inner'>
        <div className='flip-card-front'>
          <p className='flip-card-front-index'>{index + 1}</p>
        </div>
        <div className='flip-card-back'>
          <p>{info}</p>
        </div>
      </div>
    </div>
  );
}

export default Card;
